// Import controller interfaces
import {
    IEndorsementMortgageeController
} from '../Interfaces/ControllerInterfacesBarrel';
// Import api models.
import {
    ErrorMessage,
    MortgageeRequest,
    MortgageeRequestWithId,
} from '@app/models/api';
// Import api base controller.
import ApiController from './ApiController';

export default class ProductionEndorsementMortgageeController extends ApiController implements IEndorsementMortgageeController {

    private readonly controllerUrl: string = 'v2/endorsementMortgagee';

    public constructor() {
        super();
    }

    public async updateMortgagees(policyId: number, zipCode: string, mortgageesToAdd: MortgageeRequest[], mortgageesToUpdate: MortgageeRequestWithId[], mortgageesToDelete: string[]): Promise<{ policyId: number; message: string; }> {
        let url: string = `${this.controllerUrl}/public/${policyId}/${zipCode}`;

        let data = {
            mortgageesToAdd,
            mortgageesToUpdate,
            mortgageesToDelete,
        };

        try {
            let response: Response = await super.makePostCall(url, data, undefined, undefined, false);
            return await response.json();
        }
        catch (error) {
            if (ErrorMessage.isErrorMessage(error)) {
                error.message = `Could not update mortgagees for policy # ${policyId}.`;
            }
            throw error;
        }
    }
};